import { useSelector } from 'react-redux';

import { selectAppliedDesignSet } from '@lib/core/retailers/selectors/retailerLocation';

export const useRetailerDesignSet = () => {
  return useSelector(selectAppliedDesignSet);
};
